import { onMessage } from "firebase/messaging";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { Navigate, Route, Routes } from "react-router-dom";
import { getDeviceFCM, messaging } from "./firebase";
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicy";
import CancellationAndRescheduling from "components/CancellationAndRescheduling/CancellationAndRescheduling";

const App = () => {
  const [isReRenderd, setIsReRenderd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkIOSDevice =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const checkForServiceWorker = async () => {
    if (!("serviceWorker" in navigator)) {
      setIsLoading(false);
      return Error("No Support For The Service Worker!!");
    }
    if (!("Notification" in window)) {
      return Error("No Support For Notifications!!");
    }
  };

  const registerSW = async () =>
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");

  const subscribeToPushNotifications = async (registration) => {
    try {
      await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey:
          "BPtJBqotUZCashAHtgiakgOLgDZ-qro0lTEcf59TO2iV8qJMbnkBo--cbiES_KDU_30jIZ92hPHO5HZ5M3Bv2DY",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleServiceWorkerActivated = async (registration) => {
    try {
      await navigator.serviceWorker.ready;
      await subscribeToPushNotifications(registration);
      const currentToken = await getDeviceFCM();
      if (!currentToken) {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const initializeServiceWorker = async () => {
    try {
      setIsLoading(true);
      if ("serviceWorker" in navigator && navigator.serviceWorker) {
        await checkForServiceWorker();
        if (!checkIOSDevice) {
          const registration = await registerSW();
          const serviceWorker =
            registration.installing ||
            registration.waiting ||
            registration.active;

          if (serviceWorker) {
            try {
              await Notification.requestPermission();
              await navigator.serviceWorker.ready;

              // Delay re-render to ensure activation
              setTimeout(() => setIsReRenderd(true), 1000);

              if (serviceWorker.state === "activated") {
                await subscribeToPushNotifications(registration);
                const currentToken = await getDeviceFCM();
                if (currentToken) {
                  localStorage.setItem("deviceFCM", currentToken);
                  setIsLoading(false);
                  return;
                }
              }
            } catch (error) {
              setIsLoading(false);
            } finally {
              setIsLoading(false);
            }

            if (serviceWorker.state !== "activated") {
              serviceWorker.addEventListener("statechange", (e) => {
                if (e.target.state === "activated") {
                  handleServiceWorkerActivated(registration);
                }
              });
            }
          } else {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (checkIOSDevice) {
      setIsLoading(false);
    } else {
      initializeServiceWorker();
      if (messaging) {
        onMessage(messaging, (payload) => {
          // console.log('Message received:', payload.notification);
        });
      }
    }
  }, []);

  const isAuthenticated = !!localStorage.getItem("accessToken");

  return (
    <>
      {isLoading ? (
        <div className="flex min-h-[100vh] items-center justify-center text-center">
          <ReactLoading type="spin" color="#4318FF" height={60} width={60} />
        </div>
      ) : (
        <Routes>
          {/* Public Policies */}
          <Route path="policy/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="policy/cancellation-and-rescheduling"
            element={<CancellationAndRescheduling />}
          />

          {isAuthenticated ? (
            <>
              {/* Authenticated Routes */}
              <Route path="admin/*" element={<AdminLayout />} />
              <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
            </>
          ) : (
            <>
              {/* Guest Routes */}
              <Route path="auth/*" element={<AuthLayout />} />
              <Route path="/" element={<Navigate to="/auth/log-in" replace />} />
              <Route path="*" element={<Navigate to="/auth/log-in" replace />} />
            </>
          )}
        </Routes>
      )}
    </>
  );
};

export default App;